module.exports = __webpack_public_path__ + "img/stop.62fc7bd9.png";